// Theme: rainy-neon
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'rainy-neon',
  name: 'RAINY NEON',
  tagline: 'RAINY NEON',
  description: 'Reflexo de luzes molhadas no asfalto noir.',
  category: 'neon-cyber',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#0F141E', '#1A2030', '#BFDBFE', '#E0F2FE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 28%, transparent)'
    },
    shellClasses: 'font-mono theme-rainy-neon'
  },
  colorVars: {
    '--accent': '#BFDBFE',
    '--accent-foreground': '#0F141E',
    '--background': '#0F141E',
    '--border': '#3A5070',
    '--card': '#1A2030',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E0F2FE',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F141E',
    '--foreground': '#E0F2FE',
    '--hold-fill': '#BFDBFE',
    '--input': '#3A5070',
    '--modal-bg': '#0F141E',
    '--modal-border': '#3A5070',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A5070',
    '--muted-foreground': '#E0F2FE',
    '--nav-active': '#BFDBFE',
    '--nav-bg': '#1A2030',
    '--popover': '#1A2030',
    '--popover-foreground': '#E0F2FE',
    '--primary': '#BFDBFE',
    '--primary-foreground': '#0F141E',
    '--ring': '#BFDBFE',
    '--secondary': '#3A5070',
    '--secondary-foreground': '#E0F2FE',
    '--streak': '#BFDBFE',
    '--success': '#22c55e',
    '--success-foreground': '#0F141E',
    '--xp': '#BFDBFE',
    '--xp-bg': '#1A2030'
  },
  resolvedVars: {
    '--accent': '#BFDBFE',
    '--accent-foreground': '#0F141E',
    '--accent-foreground-hsl': '220 33% 9%',
    '--accent-foreground-oklch': 'from #0F141E l c h',
    '--accent-hsl': '213 97% 87%',
    '--accent-oklch': 'from #BFDBFE l c h',
    '--background': '#0F141E',
    '--background-hsl': '220 33% 9%',
    '--background-oklch': 'from #0F141E l c h',
    '--border': '#3A5070',
    '--border-hsl': '216 32% 33%',
    '--border-oklch': 'from #3A5070 l c h',
    '--border-w': '1px',
    '--card': '#1A2030',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E0F2FE',
    '--card-foreground-hsl': '204 94% 94%',
    '--card-foreground-oklch': 'from #E0F2FE l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '224 30% 15%',
    '--card-oklch': 'from #1A2030 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F141E',
    '--destructive-foreground-hsl': '220 33% 9%',
    '--destructive-foreground-oklch': 'from #0F141E l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E0F2FE',
    '--foreground-hsl': '204 94% 94%',
    '--foreground-oklch': 'from #E0F2FE l c h',
    '--hold-fill': '#BFDBFE',
    '--hold-fill-hsl': '213 97% 87%',
    '--hold-fill-oklch': 'from #BFDBFE l c h',
    '--input': '#3A5070',
    '--input-hsl': '216 32% 33%',
    '--input-oklch': 'from #3A5070 l c h',
    '--modal-bg': '#0F141E',
    '--modal-bg-hsl': '220 33% 9%',
    '--modal-bg-oklch': 'from #0F141E l c h',
    '--modal-border': '#3A5070',
    '--modal-border-hsl': '216 32% 33%',
    '--modal-border-oklch': 'from #3A5070 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A5070',
    '--muted-foreground': '#E0F2FE',
    '--muted-foreground-hsl': '204 94% 94%',
    '--muted-foreground-oklch': 'from #E0F2FE l c h',
    '--muted-hsl': '216 32% 33%',
    '--muted-oklch': 'from #3A5070 l c h',
    '--nav-active': '#BFDBFE',
    '--nav-active-hsl': '213 97% 87%',
    '--nav-active-oklch': 'from #BFDBFE l c h',
    '--nav-bg': '#1A2030',
    '--nav-bg-hsl': '224 30% 15%',
    '--nav-bg-oklch': 'from #1A2030 l c h',
    '--popover': '#1A2030',
    '--popover-foreground': '#E0F2FE',
    '--popover-foreground-hsl': '204 94% 94%',
    '--popover-foreground-oklch': 'from #E0F2FE l c h',
    '--popover-hsl': '224 30% 15%',
    '--popover-oklch': 'from #1A2030 l c h',
    '--primary': '#BFDBFE',
    '--primary-foreground': '#0F141E',
    '--primary-foreground-hsl': '220 33% 9%',
    '--primary-foreground-oklch': 'from #0F141E l c h',
    '--primary-hsl': '213 97% 87%',
    '--primary-oklch': 'from #BFDBFE l c h',
    '--radius': '10px',
    '--ring': '#BFDBFE',
    '--ring-hsl': '213 97% 87%',
    '--ring-oklch': 'from #BFDBFE l c h',
    '--secondary': '#3A5070',
    '--secondary-foreground': '#E0F2FE',
    '--secondary-foreground-hsl': '204 94% 94%',
    '--secondary-foreground-oklch': 'from #E0F2FE l c h',
    '--secondary-hsl': '216 32% 33%',
    '--secondary-oklch': 'from #3A5070 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 28%, transparent)',
    '--streak': '#BFDBFE',
    '--streak-hsl': '213 97% 87%',
    '--streak-oklch': 'from #BFDBFE l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F141E',
    '--success-foreground-hsl': '220 33% 9%',
    '--success-foreground-oklch': 'from #0F141E l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(213 97% 87% / 0.15)',
    '--xp': '#BFDBFE',
    '--xp-bg': '#1A2030',
    '--xp-bg-hsl': '224 30% 15%',
    '--xp-bg-oklch': 'from #1A2030 l c h',
    '--xp-hsl': '213 97% 87%',
    '--xp-oklch': 'from #BFDBFE l c h'
  }
}
